import React, { useState, useEffect } from "react";
import { Form, Input, Button, Typography, message, Row, Col } from "antd";
import { RightOutlined ,ArrowRightOutlined} from "@ant-design/icons";
import LeftLayout from "../pageHeader/LeftLayout";
import { useHistory, useLocation } from "react-router-dom";
import { routes } from "../../routes/Routes";
import { COMMON_ERROR_MSG, ERROR_INVALID_OTP, SESSION_TOKEN } from "../../constants/constants";
import _NewapplicationService from "../../modules/NewapplicationService";
import IntegerInput from "../../components/IntergerInput";
import { redirectToFirmAdminDashboard } from "../../utils/firmAdminRedirect";

const { Title, Text, Link } = Typography;

const VerifyOtp = () => {
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(30);
  const history = useHistory();
  const location = useLocation();
  const getQueryParams = () => {
    return new URLSearchParams(location.search);
  };
  const query = getQueryParams();
  const emailID = query.get('email');
  const sponserId = query.get('Id');
  const roleId = query.get('rid');
  const token = query.get('token');
// if (roleId) {
//   localStorage.setItem('RoleId', roleId);
// }

  const onAlreadyHaveAccountClick = () => {
    history.push(routes.roleLoginClient.path);
  };

  const applicantMailId = location?.state?.applicantMailID;
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => setTimer((t) => t - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);
  // const onBack =()=>{
  //   history.push(routes.verifyEmail.path);
  // }
  const onFinish = async (values) => {
    setLoading(true);
    let obj = {
      Email: emailID ? emailID : applicantMailId,
      EmailOTP: values.otp,
      sponserId: sponserId,
      RoleId : roleId,
      Token : token,
    }
    try {
      const res = await _NewapplicationService.verifyOtp(obj);
      debugger
      if (res?.data.IsSuccess) {
        setLoading(false);
        message.success(res?.data?.Message);
        localStorage.setItem("ApplicationId", res?.data?.Obj?.ApplicationId);
        localStorage.setItem("ApplicationEmailId", res?.data?.Obj?.Email);
        localStorage.setItem("Id", res?.data?.Obj?.Id);
        localStorage.setItem(SESSION_TOKEN, res?.data?.Obj?.AuthToken);
        localStorage.setItem("userRole", res?.data?.Obj?.Role);
        localStorage.setItem("RoleId", res?.data?.Obj?.RoleId);
        localStorage.setItem("ApplicationObjId", res?.data?.Obj?.Id);
        localStorage.setItem("BankerId", res?.data?.Obj?.BankerId);
        localStorage.setItem("BankAdminId", res?.data?.Obj?.BankAdminId);
        localStorage.setItem("SponserIdForFirmLogin",res?.data?.Obj?.SponserId);
        const isSubscriptionCorporateFirmAdmin = res?.data?.Obj?.Is_Subscription_Corporate_FirmAdminUser === true;
        if(res?.data?.Obj?.IsEmailExistCountForPassword === 0) {
           history.push({
          pathname: routes.createNewPasswordForUser.path,
          state: { email: emailID || applicantMailId, redirectToFirmAdmin: isSubscriptionCorporateFirmAdmin }
        });
        } else if (isSubscriptionCorporateFirmAdmin) {
          await redirectToFirmAdminDashboard(emailID || applicantMailId, res?.data?.Obj?.CurrentPassword, history);
        } else {
          localStorage.setItem("isFromMyApplicationsList", false);
           localStorage.setItem("IsKey",res?.data?.Obj?.CurrentPassword);
           history.push({
          pathname: routes.ApplicantsDetails.path,
          state: { email: emailID || applicantMailId}
        });
        }
       
      }
      else {
        setLoading(false);
        message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
      }

    } catch (err) {
      setLoading(false);
      message.error(err.Message || ERROR_INVALID_OTP);
    }
    finally {
      setLoading(false);
    }

  };
  // const handelResendOtp = async()=>{
  //     setLoading(true);
  //       let obj = {
  //           email: ""
  //       }
  //       try {
  //           const res = await _NewapplicationService.verifyEmail(obj);
  //           if (res.data.isSuccess) {
  //               setLoading(false);
  //               message.success(OTP_SENT);
  //               history.push("/verifyotp");
  //           }
  //       } catch (err) {
  //           setLoading(false);
  //           message.error(err.message || ERROR_SENDING_OTP);
  //       }
  // }

  return (
    <LeftLayout>
      <Row>
        <Col span={24} direction="vertical" size="middle" className="subBackgroundLayout  mt40">
          <div>
            <Title level={3}>Verify Your Email</Title>
            <Text  className="header-component__subtitle">
              A six digit Verification Code was sent to  <Text strong>{emailID || applicantMailId || "your email"}</Text>
            </Text>
            <Form
              name="otp-verification"
              layout="vertical"
              onFinish={onFinish}
              requiredMark={true}
              style={{ marginTop: 28 }}
              className="form-new inputBoxStyle" 
            >
              <Form.Item
                label="Enter Verification Code" 
                name="otp"
                rules={[
                  { required: true, message: "Verification Code is required" },
                  {
                    pattern: /^\d{6}$/,
                    message: "Verification Code must be a 6-digit number",
                  },
                ]}
              >
                <IntegerInput
                  maxLength={6}
                  placeholder="Enter 6-digit Verification Code"
                  autoComplete="one-time-code"
                />
              </Form.Item>
              <div style={{ display: "flex", gap: 16, marginTop: 24 }}>

                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  disabled={!emailID || !token}
                  className="w100"
                >
                  Confirm Verification Code <ArrowRightOutlined />
                </Button>

              </div>

              {/* <Form.Item className="mt10">
                <Link onClick={onAlreadyHaveAccountClick}>
                  Already have an User Account? <RightOutlined />
                </Link>
              </Form.Item> */}
            </Form>
            {/* <Text type="secondary" style={{ display: "block", marginTop: 32,marginBottom:15, fontSize: 15 }}>
            Wait for 30 seconds before you can resend OTP:&nbsp;
            <span style={{ fontWeight: 500 }}>
              00:{timer.toString().padStart(2, "0")}
            </span>
          </Text> */}
            {/* <Button shape="round" onClick={handelResendOtp}>Resend</Button> */}

          </div>
        </Col>
      </Row>
    </LeftLayout>
  );
};

export default VerifyOtp;